module.exports = __webpack_public_path__ + "media/מ.5945543c.mp3";